import ModelUtil from '@leverege/model-util'
import I18N from '@leverege/i18n'
import { Config } from '@leverege/plugin'

const { t, tf, exists } = I18N.ns( 'condition.ExpressionCondition' )

const TYPE = 'condition.Expression'

function create( options ) {
  const opts = options || {}
  return {
    type : TYPE,
    expression : opts.expression || null
  }
}

export default { 
  TYPE,
  create,
  handles : () => true,
  name : tf( 'name' ),
  layout : () => { return Config.get( 'ExpressionCondition', 'layout', { sort : 'Expression' } ) },
  help : () => { return exists( 'help' ) ? t( 'help' ) : null },
  ...ModelUtil.createAllValue( 'expression' )
}
